module.exports = __webpack_public_path__ + "static/assets/a9f6f72e3909594d254c5875fb99599f.png";